var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKNet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "65.1px",
    height: "29.282px",
    viewBox: "0 0 65.1 29.282",
    enableBackground: "new 0 0 65.1 29.282",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 21.695,
    fill: "#0872B9",
    width: 40.412,
    height: 7.587
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.086,
    fill: "#0872B9",
    width: 40.412,
    height: 7.587
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8.334,
    fill: "#0872B9",
    width: 40.412,
    height: 12.784
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.521,2.726h-3.382l0.248,0.413h3.38l1.155,0.742c0,0,0.248,0.247,0.083,0.412l-1.319,0.99h-6.433 l-0.495-0.66v1.814h-8V2.891h5.854v1.814h-3.381v0.66h3.959h0.165V2.973h2.228l1.318,1.319h3.794v-0.66h-3.794l-1.813-1.814 h5.855L38.521,2.726z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.83,
    y: 5.777,
    fill: "#FFFFFF",
    width: 0.824,
    height: 0.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.81,
    y: 5.777,
    fill: "#FFFFFF",
    width: 0.825,
    height: 0.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.366,
    y: 2.231,
    fill: "#FFFFFF",
    width: 1.153,
    height: 1.072
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.851,
    y: 2.231,
    fill: "#FFFFFF",
    width: 1.155,
    height: 1.072
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.335,
    y: 2.231,
    fill: "#FFFFFF",
    width: 1.155,
    height: 1.072
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.892,
    y: 3.963,
    fill: "#FFFFFF",
    width: 2.969,
    height: 1.072
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "15.758,3.551 17.819,3.551 17.819,5.942 2.479,5.942 1.325,4.458 3.304,1.818 4.871,1.818  3.716,4.458 13.861,4.458 13.861,3.633 15.263,3.633 15.263,4.458 15.758,4.458  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.49,27.797H8.17V25.57c0-0.493,0-0.741-0.083-0.905c-0.083-0.166-0.165-0.248-0.248-0.33 C7.756,24.25,7.591,24.25,7.426,24.25c-0.247,0-0.413,0.084-0.577,0.166s-0.33,0.248-0.33,0.412 c-0.082,0.164-0.165,0.494-0.165,0.989v1.979H5.119v-4.371h1.154v0.66c0.413-0.496,0.989-0.742,1.567-0.742 c0.248,0,0.495,0.082,0.742,0.164s0.412,0.248,0.495,0.33c0.083,0.166,0.166,0.33,0.248,0.496 c0.082,0.164,0.082,0.412,0.082,0.742v2.721H9.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M21.366,26.396l1.237,0.165c-0.166,0.412-0.413,0.742-0.742,0.988c-0.329,0.248-0.824,0.33-1.319,0.33 c-0.824,0-1.484-0.246-1.814-0.741c-0.33-0.412-0.495-0.907-0.495-1.484c0-0.741,0.247-1.319,0.66-1.731 c0.412-0.412,0.907-0.578,1.567-0.578c0.742,0,1.236,0.248,1.648,0.66c0.413,0.412,0.578,1.072,0.578,1.979h-3.134 c0,0.33,0.083,0.578,0.33,0.825c0.166,0.165,0.412,0.247,0.742,0.247c0.165,0,0.33-0.082,0.495-0.164 C21.201,26.808,21.283,26.643,21.366,26.396z M21.449,25.241c0-0.328-0.083-0.576-0.248-0.742 c-0.165-0.164-0.413-0.246-0.66-0.246s-0.494,0.082-0.66,0.246c-0.165,0.166-0.248,0.414-0.248,0.742H21.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.211,23.426v0.908h-0.824v1.73c0,0.33,0,0.577,0,0.66c0,0.082,0.083,0.082,0.083,0.165 c0.083,0,0.165,0.082,0.247,0.082s0.247,0,0.495-0.082l0.082,0.905c-0.33,0.084-0.659,0.166-0.99,0.166 c-0.247,0-0.412,0-0.577-0.082c-0.165-0.084-0.33-0.166-0.412-0.248c-0.083-0.082-0.165-0.248-0.165-0.412 c0-0.165-0.083-0.412-0.083-0.824v-1.896H33.49V23.59h0.576v-0.906l1.237-0.659v1.565h0.908L36.211,23.426L36.211,23.426z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.943,
    y: 9.324,
    fill: "#FBED1F",
    width: 9.567,
    height: 10.227
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBED1F",
    points: "15.181,13.86 22.273,9.406 34.892,9.406 27.964,13.86 35.47,19.385 21.943,19.385  15.346,14.272  "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKNet);
export default __webpack_public_path__ + "static/media/k_net.4652f69b751d9514ceb8b2744adabcac.svg";
export { ForwardRef as ReactComponent };